import { format } from 'date-fns'

export const generateExcelFileName = (competenceDate: string) => {
  const now = new Date()
  const [year, month] = competenceDate.split('-')
  
  const period = `P${month}${year}`
  const generationDate = format(now, 'ddMMyyyy')
  const generationTime = format(now, 'HHmmss')

  return `PreviaConsolidada_${period}_${generationDate}_${generationTime}.xlsx`
}